/** @format */
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import {
	align,
	font,
	fontColor,
	fontSize,
	formatBlock,
	hiliteColor,
	horizontalRule,
	lineHeight,
	list,
	paragraphStyle,
	table,
	template,
	textStyle,
	image,
	link,
	blockquote,
} from 'suneditor/src/plugins';

const SunTextEditor = ({
	defaultValue,
	handelChange,
	textEditorImageUpload,
}) => {
	return (
		<div>
			<SunEditor
				autoFocus={true}
				setOptions={{
					showPathLabel: false,
					minHeight: '50vh',
					maxHeight: '50vh',
					imageMultipleFile: false,
					placeholder: 'Enter your text here!!!',
					plugins: [
						align,
						font,
						fontColor,
						fontSize,
						formatBlock,
						hiliteColor,
						horizontalRule,
						lineHeight,
						list,
						paragraphStyle,
						table,
						template,
						textStyle,
						image,
						link,
						blockquote,
					],
					buttonList: [
						['undo', 'redo', 'fullScreen', 'preview', 'print'],
						['font', 'fontSize', 'formatBlock', 'textStyle'],
						['paragraphStyle'],
						[
							'bold',
							'blockquote',
							'underline',
							'italic',
							'strike',
							'subscript',
							'superscript',
						],
						['fontColor', 'hiliteColor'],
						['removeFormat'],
						'/', // Line break
						['outdent', 'indent'],
						['align', 'horizontalRule', 'list', 'lineHeight'],
						['table', 'link', 'image'],
					],
					formats: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
				}}
				defaultValue={defaultValue}
				onChange={(content) => handelChange('description', content, true)}
				onImageUploadBefore={textEditorImageUpload}
				onImageUpload={(
					targetElement,
					index,
					state,
					info,
					remainingFilesCount,
					core,
				) => {
					if (targetElement?.src?.search('data:') !== -1) {
						targetElement?.remove();
					}
					return targetElement;
				}}
			/>
		</div>
	);
};

export default SunTextEditor;
